import React from 'react';
import { Redirect, useLocalSearchParams, usePathname } from 'expo-router';
import { buildDashboardPath } from '../../../../lib/dashboardRoutes';

export default function LegacyProjectFeedRedirect() {
    const { digestId, relevance, feedback } = useLocalSearchParams<{
        digestId: string;
        relevance?: string;
        feedback?: string;
    }>();
    const pathname = usePathname();

    if (!digestId) {
        return null;
    }

    return (
        <Redirect
            href={{
                pathname: buildDashboardPath(pathname, `/${digestId}`),
                params: {
                    relevance,
                    feedback,
                },
            }}
        />
    );
}
